import React from 'react';
import Table from 'react-bootstrap/Table';

/*
 Takes a prop of data, which is an array of objects.
 Example:
[
  {"Allocation_Type":"Sector","Asset_Id":35040430,"ShareClass_Id":60052417,"Item_Id":53203,"Item_Name":"Financials","Item_Weight":8.4506,"Item_Rank":5},
  {"Allocation_Type":"Sector","Asset_Id":35040430,"ShareClass_Id":60052417,"Item_Id":53202,"Item_Name":"Health Care","Item_Weight":6.7593,"Item_Rank":6},
]

The array should already be sorted by Item_Rank
 */

const AllocationTable = ({ data }) => {
  const colHeader = data.length > 0 ? (data[0].Allocation_Type) : '';
  const header = data.length > 0 ? ("Allocation by "  + data[0].Allocation_Type) : '';
  return (
    <div>
      <h3>{header}</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>{colHeader}</th>
            <th>Weight</th>
          </tr>
        </thead>
        <tbody>
          {data.map(obj => (
            <tr key={obj.Item_Id}>
              <td className="tableitem">{obj.Item_Name}</td>
              <td className="tableitem" style={{ textAlign: 'right' }}>{obj.Item_Weight.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
export default AllocationTable;